import Select from "./Select";
import SelectListComponent from "./SelectListComponent";
import useObjectEditStore from "../../../store/useObjectEditStore";
import {fontFamilyVariants} from "../../../utils/consts";
import {useEffect} from "react";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";

const FontSelect = () => {
  const store = useEditorPanelButtonStore();
  const objectEditStore = useObjectEditStore();

  useEffect(() => {
    if (store.isOpenModal === 'font') {
      const objectEdit = () => {
        if (objectEditStore.objectEdit.element) {
          objectEditStore.objectEdit.element.style.fontFamily = objectEditStore.fontFamily;
          return {
            ...objectEditStore.objectEdit,
            fontFamily: objectEditStore.fontFamily,
          };
        }
        return objectEditStore.objectEdit
      }
      objectEditStore.setObjectEdit(objectEdit());
    }
  }, [objectEditStore.fontFamily])

  return (
    <Select tab='font' buttonContent={<span className="select__text">Font</span>}>
      <SelectListComponent tab='font' setState={objectEditStore.setFontFamily} state={objectEditStore.fontFamily} variants={fontFamilyVariants} isFont={true}/>
    </Select>
  );
};
export default FontSelect;
